export default __webpack_public_path__ + "static/media/user4_2x.04d53ca6.png";